import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'ark-lib-thank-you-feedback-modal',
  templateUrl: './thank-you-feedback-modal.component.html',
  styleUrls: ['./thank-you-feedback-modal.component.css'],
})
export class ThankYouFeedbackModalComponent  implements OnInit {

  constructor(
    private modalCtrl: ModalController,
  ) { }

  
  ngOnInit() {
    setTimeout(() => {
      this.dismiss();
    }, 3000);
  }
 
   dismiss() {
     this.modalCtrl.dismiss();
   }
}
